import React, { useMemo } from 'react'

import Chart from './LineChart.d3'
import ChartWrapper from '../ChartWrapper'

const LineChart = ({
  data,
  lineKeys,
  inModal,
  chartId,
  relations,
  setSelection = () => {},
}) => {
  const updateProps = useMemo(
    () => ({
      data,
      lineKeys,
    }),
    [data, lineKeys],
  )

  return (
    <ChartWrapper
      Chart={Chart}
      initProps={{
        data,
        relations,
        setSelection,
        lineKeys,
        inModal,
        chartId,
      }}
      updateProps={updateProps}
      margin={{ BOTTOM: 20, LEFT: 30, TOP: 20 }}
    />
  )
}

export default LineChart
